import * as dto from '@epicuro-next/data/baskets-dto';
import {
  BasketRowsGroup,
  BasketRowsGroupType,
} from 'graphql-api/baskets-api-interfaces';

import {
  getNestedObjects,
  GetRowsFn,
  GroupingFn,
  groupItemsByAddress,
  Mappings,
} from '../mappings';

/**
 * Top level grouping by address.
 */
export function groupByAddress(
  items: dto.Item[],
  maps: Mappings,
  groupFn?: GroupingFn,
  getRowsFn?: GetRowsFn,
): BasketRowsGroup[] {
  const addressItemsMap = groupItemsByAddress(items, maps.deliveries);

  return Object.keys(addressItemsMap).map((addressId) => {
    const addressItems = addressItemsMap[addressId];
    const address = maps.addresses[addressId];
    const subTitle =
      [address.city, address.street, address.zipCode, address.country]
        .filter(Boolean)
        .join(', ') || undefined;

    const nested = getNestedObjects(addressItems, maps, groupFn, getRowsFn);

    return {
      id: addressId,
      type: BasketRowsGroupType.Address,
      details: getAddressGroupDetails(addressItems, maps),
      title: address.name,
      subTitle,
      ...nested,
    };
  });
}

export function getAddressGroupDetails(items: dto.Item[], maps: Mappings) {
  const basketAccountId = items.pop()?.basketAccountId || '';
  const basketAccount = maps.basketAccounts[basketAccountId];
  return {
    accountId: basketAccount.account?.accountId,
    externalAccountId: basketAccount.account?.realAccountId,
    addressId: basketAccount.address?.addressId ?? basketAccount.addressId,
    realAddressId: basketAccount.address?.realAddressId,
    clientReferenceNumber: basketAccount.clientReferenceNumber,
    deletedAtUtc: basketAccount.address?.deletedAtUtc,
  };
}
